import React from "react";

import { FallbackHistoryItem } from "./fallback-history-item";
import type { EntityHistoryEntry } from "./types";

export type HistoryItemComponent<T extends EntityHistoryEntry = EntityHistoryEntry> =
  React.ComponentType<{ entry: T }>;

export type HistoryItemMap<T extends EntityHistoryEntry = EntityHistoryEntry> =
  Record<string, HistoryItemComponent<T>>;

interface HistoryEntryDispatcherProps<T extends EntityHistoryEntry> {
  entry: T;
  items: HistoryItemMap<T>;
  /** i18n prefix for the fallback (`sourceLabel`, `noDetails`, `unknownType`) */
  i18nPrefix: string;
}

export function HistoryEntryDispatcher<T extends EntityHistoryEntry>({
  entry,
  items,
  i18nPrefix,
}: HistoryEntryDispatcherProps<T>) {
  const Component = items[entry.changeType];
  if (Component) return <Component entry={entry} />;
  return <FallbackHistoryItem entry={entry} i18nPrefix={i18nPrefix} />;
}
